import { makePropCacheMixin } from '../utils/cache';
export var listenersMixin = makePropCacheMixin('$listeners', 'bvListeners');


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/mixins/listeners.js
// module id = NMbJ
// module chunks = 22